import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.remount = this.remount.bind(this);
    document.addEventListener("cable-ready:after-morph", this.remount);
    document.addEventListener("cable-ready:after-inner-html", this.remount);
    this.mount();
  }

  disconnect() {
    document.removeEventListener("cable-ready:after-morph", this.remount);
    document.removeEventListener("cable-ready:after-inner-html", this.remount);
    this.destroy();
  }

  remount() {
    if (!this.element.isConnected) return;
    if (this.slim && this.mounted) return;
    this.mount();
  }

  mount() {
    if (typeof SlimSelect === "undefined") return;
    this.destroy();

    this.slim = new SlimSelect({
      select: this.element,
      settings: {
        placeholderText: this.element.dataset.placeholder || "Aucun",
        searchPlaceholder: "Rechercher...",
        searchText: "Pas de résultats",
      },
    });
  }

  destroy() {
    if (!this.slim) return;
    try { this.slim.destroy(); } catch (e) {}
    this.slim = null;
  }

  get mounted() {
    const next = this.element.nextElementSibling;
    return !!next && next.classList.contains("ss-main");
  }
}
